export default __webpack_public_path__ + "static/media/discoverBooksDark@2x.caee2007.png";